import { render, staticRenderFns } from "./SocialSecuritySetting.vue?vue&type=template&id=2973e17b"
import script from "./SocialSecuritySetting.vue?vue&type=script&lang=js"
export * from "./SocialSecuritySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports